module.exports = __webpack_public_path__ + "img/greenReadingScience1.247a5b55.png";